import { Outlet } from "react-router-dom";
import MainNavigation from "../components/MainNavigation";

export default function RootLayout() {
  return (
    <div className="flex h-screen bg-gray-200">
      <div className="w-[20%]  h-full fixed">
        <MainNavigation />
      </div>

      <div className="ml-[20%] w-[80%] overflow-auto px-3 py-3">
        <Outlet />
      </div>
    </div>
  );
}
